import {
  saveAdminDesign,
  uploadAdminAsset,
  type DesignInput,
} from '../../api/client';

export const PENDING_DESIGN_ASSET = '/api/assets/design/pending';

interface DesignPersistenceDependencies {
  saveDesign: typeof saveAdminDesign;
  uploadAsset: typeof uploadAdminAsset;
}

const defaultDependencies: DesignPersistenceDependencies = {
  saveDesign: saveAdminDesign,
  uploadAsset: uploadAdminAsset,
};

interface PersistDesignOptions {
  existingId?: string;
  stagedId?: string;
  onStaged?: (id: string) => void;
  dependencies?: DesignPersistenceDependencies;
}

export async function persistAdminDesign(
  value: DesignInput,
  image: File | null,
  options: PersistDesignOptions = {},
): Promise<{ id: string }> {
  const dependencies = options.dependencies || defaultDependencies;

  if (!image) return dependencies.saveDesign(value, options.existingId || options.stagedId);

  if (options.existingId) {
    const saved = await dependencies.saveDesign(value, options.existingId);
    await dependencies.uploadAsset('design', saved.id, image);
    return saved;
  }

  let designId = options.stagedId;
  if (!designId) {
    const staged = await dependencies.saveDesign({
      ...value,
      asset: PENDING_DESIGN_ASSET,
      thumbnail: PENDING_DESIGN_ASSET,
      active: false,
    });
    designId = staged.id;
    options.onStaged?.(designId);
  }

  const uploaded = await dependencies.uploadAsset('design', designId, image);
  await dependencies.saveDesign({
    ...value,
    asset: uploaded.url,
    thumbnail: uploaded.url,
  }, designId);
  return { id: designId };
}
